// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-IQe","input":"styles_input__1rS6a"};